// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"497cd41b","921":"4c6af785"}[chunkId] + ".chunk.css";
};